var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnalyzeNavigationActive = function SvgAnalyzeNavigationActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1932_18249)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1932_18249)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3714 17.0715C10.8842 17.2766 11.1336 17.8586 10.9285 18.3714L8.92848 23.3714C8.72336 23.8842 8.14139 24.1336 7.62861 23.9285C7.11583 23.7234 6.86641 23.1414 7.07152 22.6286L9.07152 17.6286C9.27664 17.1158 9.85861 16.8664 10.3714 17.0715Z",
    fill: "#FF4473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6286 17.0715C13.1158 17.2766 12.8664 17.8586 13.0715 18.3714L15.0715 23.3714C15.2766 23.8842 15.8586 24.1336 16.3714 23.9285C16.8842 23.7234 17.1336 23.1414 16.9285 22.6286L14.9285 17.6286C14.7234 17.1158 14.1414 16.8664 13.6286 17.0715Z",
    fill: "#FF4473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V15C24 17.2091 22.2091 19 20 19H4C1.79086 19 0 17.2091 0 15V4ZM19.9989 4.95203C19.9996 4.96801 20 4.984 20 5V5.00196V9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9V7.41421L16.9571 8.45711L14.2071 11.2071C14.0196 11.3946 13.7652 11.5 13.5 11.5C13.2348 11.5 12.9804 11.3946 12.7929 11.2071L11 9.41421L5.70711 14.7071C5.31658 15.0976 4.68342 15.0976 4.29289 14.7071C3.90237 14.3166 3.90237 13.6834 4.29289 13.2929L10.2929 7.29289C10.4804 7.10536 10.7348 7 11 7C11.2652 7 11.5196 7.10536 11.7071 7.29289L13.5 9.08579L16.5858 6H15C14.4477 6 14 5.55228 14 5C14 4.44772 14.4477 4 15 4H19C19.1356 4 19.2649 4.02699 19.3828 4.07588C19.5007 4.12468 19.6112 4.19702 19.7071 4.29289C19.8902 4.47595 19.9874 4.71232 19.9989 4.95203Z",
    fill: "#FF4473"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1932_18249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1932_18249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnalyzeNavigationActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/analyze-navigation-active.f78d571ab2f9046f3a897c466ef77f41.svg";